module.exports = __webpack_public_path__ + "static/media/twitter-logo.65aa8bcc.png";